var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/core-js/modules/_core.js
// module id = ../../../../core-js/modules/_core.js
// module chunks = 15